<template>
    <div class="route-detail">
        <div v-if="summaryRouteData">
            <RouteSummary :route="summaryRouteData" />

            <PublicRouteOverview :route="detailedSectionsData" v-if="summaryRouteData.mode === 'PUBLIC' || summaryRouteData.mode === 'SHARING'" :shopTransitionsFare="summaryRouteData.mode !== 'SHARING'"/>
            
            <el-tabs v-model="activeTab" :stretch="true" v-else>
                <el-tab-pane label="Überblick" name="overview">
                    <RouteOverview :route="summaryRouteData" :countryInfo="routeCountryInfo" @change-tab="changeTabHandler"/>
                </el-tab-pane>
                <el-tab-pane label="Länderinfo" name="country-info" v-if="showCountryInfo">
                    <RouteCountryInfo :countryInfo="routeCountryInfo" />
                </el-tab-pane>
                <el-tab-pane label="Strecke" name="routes">
                    <PublicRouteOverview :route="detailedSectionsData" :shopTransitionsFare="false" v-if="publicRouteStepsMode.includes(summaryRouteData.mode)"/>
                    <RouteSteps :route="summaryRouteData" :steps="routeStepsData" v-else />
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="sidebar__section" v-else>
            <ContentLoader />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDetailRoute, getDetailedRouteData, getRouteCountryInfo, getDetailedSectionsData } from '@/utils/route-utils'
import RouteSummary from '@/components/RouteSummary.vue'
import RouteOverview from '@/components/RouteOverview.vue'
import RouteCountryInfo from '@/components/RouteCountryInfo.vue'
import RouteSteps from '@/components/RouteSteps.vue'
import ContentLoader from '@/components/ContentLoader.vue'
import eventBus from '@/utils/event-bus'
import { HAS_PUBLIC_TRANSPORT } from '@/data/transportModesTypes'

export default {
    components: {
        PublicRouteOverview: () => import(/* webpackChunkName: "PublicRouteOverview" */ '@/components/PublicRouteOverview.vue'),
        RouteSummary,
        RouteOverview,
        RouteCountryInfo,
        RouteSteps,
        ContentLoader
    },
    props: {
    },
    data() {
        return {
            activeTab: 'overview',
            hideCountryInfo: ['FOOT', 'BIKE', 'PARK_AND_RIDE', 'BIKE_AND_RIDE', 'SHARING'],
            publicRouteStepsMode: ['PARK_AND_RIDE', 'BIKE_AND_RIDE', 'SHARING'],
        }
    },
    computed: {
        ...mapGetters(['detailRouteId']),
        detailRoute() {
            return getDetailRoute();
        },
        summaryRouteData() {
            return this.detailRoute ? getDetailedRouteData(this.detailRoute) : false;
        },
        detailedSectionsData() {
            if(!HAS_PUBLIC_TRANSPORT.includes(this.summaryRouteData.mode) && this.summaryRouteData.mode !== 'SHARING') return false;
            return getDetailedSectionsData(this.detailRoute);
        },
        routeCountryInfo() {
            return getRouteCountryInfo(this.detailRoute)
        },
        routeStepsData() {
            return this.summaryRouteData.steps
        },
        showCountryInfo() {
            return !this.hideCountryInfo.includes(this.summaryRouteData.mode);
        },
    },
    methods: {
        changeTabHandler(e) {
            this.activeTab = e.tab;
            if(e.action) {
                switch(e.action) {
                    case 'showTolls':
                        eventBus.$emit('showCountryInfoTolls', { country: e.country })
                        break
                }
            }
        }
    }
}
</script>

<style lang="scss">
.route-detail {
    $block: &;
  
}
</style>